import { Component, Input } from "@angular/core";
import { DateTableColumn } from "src/app/core/models/date-table-column";

@Component({
  selector: 'column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss'],
  providers: [
  ]
})

export class ColumnFilterComponent {

  @Input() tableColumn!: DateTableColumn;

  
}